import Mock from 'mockjs'

const {page, save} = require('../util');
const {targets} = require('./data');
const qs = require('qs');

Mock.mock('/target/findAll', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = page(targets, bodyObject);
    bodyObject.total = targets.length;
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/target/save', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    save(bodyObject, targets);
    return {
        code: 200,
        body: targets,
    }
});
